import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a80e9ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card alternate-items"
}
const _hoisted_2 = { class: "card-header alternate-items-heading font-weight-bold" }
const _hoisted_3 = { class: "card-body alternate-items-body px-2" }
const _hoisted_4 = { class: "alternate-item-description" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "item-pricing"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "price-new" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "price-new" }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-end flex-fill pl-2" }
const _hoisted_12 = {
  key: 0,
  class: "wc-card-button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WCBasicAddToCartButton = _resolveComponent("WCBasicAddToCartButton")!

  return (_ctx.item.alternateItems)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('alternateItems')), 1),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.alternateItems, (asc) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "alternate-item d-flex justify-content-between",
              key: asc.id
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  class: "text-primary font-weight-bold underline-link-from-center",
                  to: `/i/${asc.id}`,
                  id: asc.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(asc.name) + " ", 1),
                    (asc.ascQuantity != _ctx.item.ascQuantity)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "\n              - " + _toDisplayString(_ctx.$t('packOf')) + " " + _toDisplayString(asc.ascQuantity), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to", "id"]),
                _createTextVNode(),
                (!_ctx.shouldHideItemPrices)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (asc.actualPrice != null && asc.actualPrice >= 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('seePriceInCart')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(),
                      (asc.actualPrice == null || asc.actualPrice < 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('callForPrice')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_11, [
                (!_ctx.shouldHideItemPrices)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (!asc.hasModifiers && _ctx.showAddToCartButton)
                        ? (_openBlock(), _createBlock(_component_WCBasicAddToCartButton, {
                            key: 0,
                            item: asc,
                            class: "btn-block",
                            describedBy: asc.id
                          }, null, 8, ["item", "describedBy"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}